import TextDecode from './TextDecode';
import './_Hero.scss';

function Hero() {
  return (
    <section className="hero-container" aria-labelledby="hero-title">
      <TextDecode as="h1" className="hero-title" id="hero-title" text="Dominic Andutan" />
      <p className="hero-description">
        Software Engineer focused on reverse engineering, systems programming, and full-stack web development.
        <br />
        Check out my <a href="#projects">side projects</a> below.
      </p>
    </section>
  );
}

export default Hero;
